export default __webpack_public_path__ + "static/27183-2f6079c4d988377a4d768436fb6ccf47.jpg";